import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component } from '@angular/core';

@Component({
  selector: 'cng-agent-booking-phone-inprocess-forward',
  template: '<cng-agent-phone-forward-view [booking]="responseId$ | async"></cng-agent-phone-forward-view>',
})
export class AgentBookingPhoneInprocessForwardComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
